// Team Smith Hub Privacy Notice — PREVIEW DRAFT content. Items with `pending` are unverified and block publication.
export const NOTICE_CONTACT = "sean.rina@gmail.com";

export const NOTICE_SECTIONS = [
  {
    id: "who", title: "Who we are",
    paras: [
      "Team Smith Hub is operated by Rina and Sean W Smith Music Trust. The Hub supports partner training, coaching, appointment coordination and business progress tracking.",
      `For privacy questions, requests, complaints or enquiries, email ${NOTICE_CONTACT}.`,
    ],
  },
  {
    id: "collect", title: "What we collect",
    paras: ["About registered users, the Hub holds:"],
    list: [
      "Your name, the email address you sign in with, and the profile photo link supplied by Google sign-in.",
      "Your account role, approval and active status, team, and nearest upline leader (your team and coaching relationships).",
      "Bootcamp training progress, business milestones and qualification history (including who recorded each change and when).",
      "Appointment and process records you or your leaders enter, activity entries and conference attendance responses.",
      "Records of your privacy acknowledgements (which notice version you acknowledged and when).",
      "Communications you send us for support.",
    ],
    after: ["Technical information:"],
    list2: [
      "Sign-in keeps you logged in using a secure session cookie (valid up to 7 days) and a sign-in token stored in your browser's local storage (valid up to 14 days). Local storage also remembers whether a leader is using read-only “View As”.",
      "Our servers record standard request logs (such as the time, the page or data requested and the network address of the request) to operate and secure the service.",
    ],
    pending: [
      "The hosting platform page template loads a usage-analytics script (PostHog, sent to ap.emergent.sh) configured for session recording. Whether it is active in the published Hub, what it captures (it could include names on screen) and where it is stored must be confirmed — or it must be switched off — before publication.",
      "How long server request logs are kept, and whether network addresses are retained, has not been confirmed.",
    ],
  },
  {
    id: "pbo", title: "PBO information",
    paras: [
      "Partners may record a PBO's name and appointment/process progress for authorised coaching and follow-up. Names and linked progress are personal information.",
      "Do not record PBO email, phone, address, birth dates, identification or payment details, health, religious or other sensitive information, private family or financial circumstances, private messages or any other unnecessary personal information in the Hub. The Hub's PBO forms accept a name (and an optional partner/spouse name) with appointment progress only.",
      `If prohibited information is accidentally entered, notify ${NOTICE_CONTACT}.`,
    ],
  },
  {
    id: "how", title: "How we collect information",
    list: [
      "Directly from you when you register and use the Hub.",
      "From Google, when you choose “Continue with Google” (your name, email address and profile photo link).",
      "From authorised partners, coaches and leaders who enter appointment and progress records.",
      "From our technical systems, as described under “What we collect”.",
    ],
  },
  {
    id: "purposes", title: "Why we use it",
    list: [
      "Managing accounts, approvals and access.",
      "Providing training and resources.",
      "Appointment coordination, coaching and follow-up.",
      "Tracking progress, milestones and qualifications.",
      "Keeping team and leader associations correct.",
      "Support and service communications.",
      "Security, and meeting legal obligations.",
    ],
    after: ["We do not ask for, and registration does not include, any optional marketing permission."],
  },
  {
    id: "access", title: "Who can see it",
    list: [
      "Partners see their own PBO records, their own Bootcamp progress and their own milestones.",
      "Leaders, Team Leaders and Platinums see the PBO records, Bootcamp progress, milestones and account details (name, login email, role, team) of people in their own downline branch, and can open a read-only “View As” preview of those people. View As cannot change anything.",
      "ATL Oversight accounts can see organisation-wide records but cannot change them.",
      "Admins can see and correct all records, approve or decline access, and use read-only View As for anyone.",
      "People requesting access can see the names and roles of recognised leaders so they can choose their upline.",
      "There is no public PBO directory. Pages beyond sign-in and this notice require an approved account.",
      "We may disclose information where required or authorised by law.",
    ],
    pending: ["Whether the hosting/development platform's staff can access stored Hub data for maintenance or support, and on what terms, has not been confirmed."],
  },
  {
    id: "providers", title: "Service providers and overseas handling",
    list: [
      "Emergent (Emergent Labs) — hosts the Hub, its database and files, and provides the Google sign-in service.",
      "Google — sign-in identity, and the Google Sheets / Drive files that hold training content.",
      "Google Fonts — page fonts are loaded from Google's servers, which receive your network address.",
      "External training links (Google Drive, Google Sheets, video and podcast services) have their own privacy practices; opening them may share technical information with those services.",
    ],
    pending: [
      "The countries where the Hub's servers, database and backups are located have not been confirmed.",
      "Countries where Emergent and the analytics provider process data have not been confirmed.",
    ],
  },
  {
    id: "security", title: "Security",
    paras: [
      "We take reasonable technical and organisational steps to protect information. Access is limited by role, sign-in is required, and read-only modes cannot change records. No system is completely secure, and we cannot guarantee absolute security.",
      `Please protect your sign-in and only access or share records within your authority. Report suspected incidents to ${NOTICE_CONTACT}. We will assess incidents and notify affected people where legally required.`,
    ],
  },
  {
    id: "retention", title: "How long we keep information",
    paras: [
      "We keep information only as long as reasonably needed for the purposes above or to meet legal obligations.",
      "The Hub does not currently delete anything automatically. Archived and deactivated accounts, dropped-out and launched PBO records, milestone history and audit records stay stored until an Admin removes them. Removed business milestones remain in history but are hidden. Closing an account does not necessarily immediately erase backups or records we must keep.",
    ],
    pending: [
      "Backup frequency and how long backups are kept by the hosting platform have not been confirmed.",
      "A retention period for inactive accounts, closed PBO records and logs has not been decided.",
    ],
  },
  {
    id: "requests", title: "Your requests",
    paras: [
      `Users and PBOs may email ${NOTICE_CONTACT} to request access to or correction of their information, removal of unnecessary information, account closure, or to ask questions. We may need proportionate checks to confirm identity, and will explain if we lawfully refuse or must retain something.`,
      "If required account information isn't provided, some or all Hub functions may be unavailable.",
    ],
  },
  {
    id: "complaints", title: "Complaints",
    paras: [
      `Email ${NOTICE_CONTACT}. We aim to acknowledge complaints within five business days and respond within 30 days, and will explain any delay.`,
      "If you are not satisfied, you may contact the Office of the Australian Information Commissioner (OAIC) at www.oaic.gov.au, subject to its jurisdiction.",
    ],
  },
  {
    id: "updates", title: "Updates to this notice",
    paras: [
      "The current notice and its date are always available in the Hub. We will tell you about material changes and ask for further acknowledgement or consent where required.",
      "Acknowledging this notice is not a waiver of your privacy rights or consent to unrestricted handling of your information.",
    ],
  },
];
